<template>
  <div
    :ref="controlRef"
    class="ms-datebox"
    :class="{ 'is-valid-datebox': errorProvider.isValid, disabled: disabled }"
  >
    <div
      v-show="editingMode"
      class="flex items-center p-relative"
      :style="{
        width: isNaN(width) ? width : width + 'px',
        height: isNaN(height) ? height : height + 'px',
      }"
    >
      <DxDateBox
        :ref="editorRef"
        :show-clear-button="showClearButton && !disabled"
        :use-mask-behavior="useMaskBehavior"
        :type="typeDateBox"
        :value="value"
        :display-format="displayFormat"
        :placeholder="placeholder"
        :apply-button-text="$t('i18nCommon.Save')"
        :cancel-button-text="$t('i18nCommon.Cancel')"
        :width="'100%'"
        :height="'100%'"
        :date-serialization-format="dateSerializationFormat"
        :max="getMaxDate"
        :min="minDateData()"
        :open-on-field-click="true"
        drop-down-button-template="button-template"
        class="datebox-input"
        @value-changed="onValueChanged"
      >
        <template #button-template>
          <div class="flex items-center justify-center h-full w-full">
            <div
              v-show="typeDateBox != 'time'"
              class="mi-calendar"
            />
            <div
              v-show="typeDateBox == 'time'"
              class="mi-clock"
            />
          </div>
        </template>
        <DxCalendarOptions
          :max-zoom-level="zoomLevel"
          :zoom-level="zoomLevel"
          min-zoom-level="decade"
        />
      </DxDateBox>
      <div
        v-if="editable"
        class="flex m-l-8"
      >
        <ms-icon
          icon="mi-file-green"
          :tooltip-content="$t('i18nCommon.Save')"
          @click="saveEditMode"
        />
        <ms-icon
          icon="mi-circle-close-red"
          :tooltip-content="$t('i18nCommon.Cancel2')"
          @click="closeEditMode"
        />
      </div>
    </div>
    <div
      v-show="editable && !editingMode"
      class="flex items-center"
      @dblclick="onDoubleClick"
    >
      <ms-text-border class="text-border">
        <span
          v-if="value"
          :title="value"
        >{{
          moment(value).format(displayFormatText)
        }}</span>
        <span
          v-if="!value"
          :title="value"
        />
        <template #icon>
          <ms-icon
            v-if="permission"
            :tooltip-content="$t('i18nCommon.Edit')"
            icon="mi-pencil"
            @click="clickEditBtn"
          />
          <ms-icon
            v-if="!permission"
            icon="mi-lock"
          />
        </template>
      </ms-text-border>
    </div>
    <p
      v-if="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import { DxDateBox, DxCalendarOptions } from "devextreme-vue/date-box";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { locale } from "devextreme/localization";
import moment from "moment";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsDatepicker",
  components: {
    DxDateBox,
    DxCalendarOptions,
  },
  extends: msBaseComponent,

  props: {
    // Hiển thị button xóa dữ liệu
    showClearButton: {
      type: Boolean,
      default: false,
    },
    isRequiredMinDate:{
      type: Boolean,
      default: false
    },
    minDate:{
      type: Date,
      default: () => new Date()
    },
    isRequiredMaxDate:{
      type: Boolean,
      default: false
    },
    maxDate:{
      type: [Date, null],
      default: () => new Date()
    },
    // dateMax: {
    //   type: Date,
    //   default: new Date(new Date().setFullYear(new Date().getFullYear() + 1000))
    // },
    // Hỗ trợ tự động nhập ngày giờ
    useMaskBehavior: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "date",
    },
    value: {
      type: [String, Date],
      default: null,
    },
    height: {
      default: 36,
      type: [String, Number],
    },
    width: {
      default: "100%",
      type: [String, Number],
    },
    tabindex: {
      type: [String, Number],
      default: 1,
    },
    autofocus: {
      type: [Boolean, String],
      default: false,
    },
    disabled: {
      type: [Boolean, String],
      default: false,
    },
    paramValidate:{
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateMax: new Date(
        new Date().setFullYear(new Date().getFullYear() + 1000)
      ),
      // set chế độ edit = fasle khi editable = true
      editingMode: false,
      // giá trị trước khi sửa nhanh
      oldValue: null,
      moment: moment,
      displayFormat: "",
      displayFormatText: "",
      placeholder: "",
      typeDateBox: "",
      dateSerializationFormat: "",
      controlRef: MsControlRef.MsDatepicker,
      editorRef: "editorRef"
    };
  },
  computed: {
    getMaxDate() {
      const me = this;
      if (me.maxDate && me.isRequiredMaxDate) {
        return me.maxDate
      }
      return me.dateMax;
    },
  },
  watch: {
    value: {
      deep: true,
      handler(newVal, oldVal) {
        this.internalText = newVal;
        this.validate();
        this.$emit("changed", newVal);
        this.$emit("changDateTime", newVal, oldVal);
        this.$nextTick(
          () =>
            this.$refs[this.editorRef].instance &&
            this.$refs[this.editorRef].instance.blur()
        );
      },
    },
    /**
     * custom validate
     */
    paramValidate: {
      immediate: true,
      deep: true,
      handler(val) {
        let me = this;
        //Nếu validate đang true và kphai custom thì return
        if (
          me.errorProvider &&
          me.errorProvider["isValid"] &&
          (!val || (val && me.errorProvider["rules"] != val.rules))
        ) {
          return;
        }

        if (val && val.isValid) {
          me.$set(me.errorProvider, "message", val.message);
          me.$set(me.errorProvider, "isValid", true);
          me.errorProvider.rules = val.rules;
          me.errorProvider.element = me.$refs.input;
        } else {
          me.errorProvider = {};
        }
      },
    },
    editable: {
      immediate: true,
      handler(val) {
        this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      },
    },
  },
  created() {
    var lang = "vi";
    if (lang == "vi") {
      locale("vi-VN");
    } else if (lang == "en") {
      locale("en-EN");
    } else {
      locale(navigator.language);
    }
    this.setType();
    this.internalText = this.value;
  },
  beforeMount() {
    this.setTabindex();
  },
  mounted() {

    if (this.autofocus && !this.disabled) {
      this.$nextTick(
        () =>
          this.$refs[this.editorRef].instance &&
          this.$refs[this.editorRef].instance.focus()
      );
    }
  },
  methods: {
    /**
     * @override
     */
    focusError(){
      this.$refs[this.editorRef].instance.open();
    },
    // set min Date
    minDateData(){
      if (this.isRequiredMinDate)
        return this.minDate
      return new Date(-8640000000000000)
    },
    /**
     * set tabindex
     * ntson2
     */
    setTabindex() {
      let me = this;
      setTimeout(() => {
        $(".ms-datebox .dx-texteditor-input").attr("tabindex", this.tabindex);
      }, 10);
    },
    getCellCssClass(date) {
      let cssClass = "";
      if (this.isWeekend(date)) {
        cssClass = "weekend";
      }
      return cssClass;
    },
    isWeekend(date) {
      const day = date.getDay();
      return day === 0 || day === 6;
    },
    onValueChanged(e) {
      if(this.typeDateBox == "date"){
        let valueTime = new Date(e.value);
        if (this.isRequiredMinDate && valueTime.getDateOnly()< this.minDate.getDateOnly()) {
          e.value = this.minDate.getDateOnly();
        } 
        if (this.isRequiredMaxDate && valueTime.getDateOnly() > this.maxDate.getDateOnly()) {
          e.value = this.maxDate.getDateOnly();
        }
      }

      this.$emit("input", e.value);
      if (e.event) {
        this.$emit("onChange", e.value);
      }
    },
    onDoubleClick() {
      this.permission && this.clickEditBtn();
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.oldValue = this.value;
        this.editingMode = !this.editingMode;
        this.$nextTick(
          () =>
            this.$refs[this.editorRef].instance &&
            this.$refs[this.editorRef].instance.focus()
        );
        this.$emit("clickEditBtn");
        this.$store.dispatch("setEditingMode", true);
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.value = this.oldValue;
      this.$emit("closeEditMode");
      this.$store.dispatch("setEditingMode", false);
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      if (!this.errorProvider.isValid) {
        this.$emit("onSaveData");
      }
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    },
    setType() {
      switch (this.type) {
        case "date":
          this.typeDateBox = "date";
          this.displayFormat = "dd/MM/yyyy";
          this.displayFormatText = "DD/MM/YYYY";
          this.placeholder = "DD/MM/YYYY";
          this.zoomLevel = "month";
          this.dateSerializationFormat = undefined;
          break;
        case "datetime":
          this.typeDateBox = "datetime";
          this.displayFormat = "dd/MM/yyyy HH:mm";
          this.displayFormatText = "DD/MM/YYYY HH:mm A";
          this.placeholder = "DD/MM/YYYY HH:mm AM";
          this.zoomLevel = "month";
          this.dateSerializationFormat = undefined;
          break;
        case "time":
          this.typeDateBox = "time";
          this.displayFormat = "HH:mm";
          this.displayFormatText = "HH:mm";
          this.placeholder = "HH:mm";
          this.dateSerializationFormat = "HH:mm:ss";
          break;
        case "month":
          this.typeDateBox = "date";
          this.type = "date";
          this.displayFormat = "'Tháng' MM, yyyy";
          this.displayFormatText = "'Tháng' MM, yyyy";
          this.placeholder = "Tháng MM, YYYY";
          this.zoomLevel = "year";
          this.dateSerializationFormat = undefined;
          break;
        case "year":
          this.typeDateBox = "date";
          this.type = "date";
          this.displayFormat = "yyyy";
          this.displayFormatText = "yyyy";
          this.placeholder = "YYYY";
          this.zoomLevel = "decade";
          this.dateSerializationFormat = undefined;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/controls/_variables.scss";
.dx-calendar-cell {
  color: var(--text-primary-color);
}
.dx-calendar-cell.dx-calendar-other-view:not(.dx-calendar-selected-date) {
  color: var(--text-disable-color);
}
.dx-calendar-body thead tr th {
  color: var(--text-disable-color);
}
.dx-datebox-wrapper-time .dx-list-item-content {
  padding: 10px !important;
}
.dx-datebox-wrapper-calendar .dx-calendar {
  margin: 10px 0 !important;
}
.dx-datebox-wrapper-time .dx-state-hover .dx-list-item-content {
  background: var(--date-picker-hover-bg);
}
.dx-calendar-caption-button {
  .dx-button-text {
    text-transform: capitalize;
  }
}
// In màu cho ngày cuối tuần và ngày hiện tại
.dx-calendar-cell:not(.dx-calendar-other-month) .weekend {
  text-shadow: none;
  font-weight: bold;
}

.dx-calendar-cell:not(.dx-calendar-other-month) .weekend {
  color: #ff3030;
}

.dx-state-disabled.dx-calendar
  .dx-calendar-cell:not(.dx-calendar-other-month)
  .weekend {
  color: #ff8080;
}
.ms-datebox.disabled {
  .datebox-input {
    background-color: $input-disable-bg-color;
    border-color: $input-disable-border;
    cursor: auto;
    pointer-events: none;
    input {
      color: $input-disable-color !important;
    }
  }
}
.ms-datebox {
  height: max-content;
  width: 100%;

  .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border-color: var(--input-hover-border-color);
  }
  .dx-texteditor.dx-editor-outlined {
    border-radius: 4px;
    &:hover {
      border-color: var(--input-hover-border-color);
    }
  }
}
// Style input khi validate error
.is-valid-datebox {
  .dx-dropdowneditor-icon {
    display: none;
  }
  .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border-color: var(--input-error-border-color);
  }
  .dx-texteditor.dx-editor-outlined {
    border-radius: 4px;
    border-color: var(--input-error-border-color);
    &:hover {
      border-color: var(--input-error-border-color);
    }
  }
}
// Style màu cho calendar
.dx-calendar-navigator
  .dx-calendar-caption-button.dx-button
  .dx-button-content {
  color: var(--primary) !important;
}
.dx-calendar-navigator-previous-month.dx-button .dx-icon,
.dx-calendar-navigator-previous-view.dx-button .dx-icon,
.dx-calendar-navigator-next-month.dx-button .dx-icon,
.dx-calendar-navigator-next-view.dx-button .dx-icon {
  color: var(--primary) !important;
}
.dx-calendar-cell.dx-calendar-selected-date.dx-calendar-contoured-date {
  box-shadow: inset 0 0 0 1px var(--date-picker-active-bg),
    inset 0 0 0 1000px var(--date-picker-active-bg) !important;
}
.dx-calendar-cell.dx-calendar-selected-date {
  box-shadow: inset 0 0 0 1px var(--date-picker-active-bg),
    inset 0 0 0 1000px var(--date-picker-active-bg) !important;
}
.dx-calendar-cell.dx-state-hover {
  box-shadow: inset 0 0 0 1px var(--date-picker-hover-bg),
    inset 0 0 0 1000px var(--date-picker-hover-bg) !important;
}
.dx-calendar-cell.dx-calendar-empty-cell.dx-state-hover {
  box-shadow: unset !important;
}

.dx-calendar-cell.dx-calendar-today {
  color: var(--date-picker-color-today);
}
// Style calendar datetime
@media screen and (max-height: 800px) {
  .dx-datebox-wrapper-datetime {
    .dx-popup-content {
      height: auto !important;
      padding: 16px !important;
      margin: 0 !important;
      .dx-timeview-clock {
        min-height: 150px;
        min-width: 150px;
        background-size: 150px;
      }
      .dx-box-flex {
        align-items: center !important;
        .dx-calendar-body {
          height: 175px !important;
          max-height: 175px !important;
          overflow-y: auto;
        }
      }
      .dx-calendar-view-month {
        margin: 0 !important;
        margin-right: 8px !important;
        height: 235px !important;
        min-height: 235px !important;
      }
      .dx-timeview {
        margin: 0 !important;
        margin-left: 8px !important;
      }
    }
    .dx-popup-bottom.dx-toolbar {
      padding: 0 16px;
      padding-bottom: 16px;
    }
  }
}
.dx-datebox-wrapper-datetime {
  .dx-popup-content {
    height: auto !important;
    padding: 16px !important;
    margin: 0 !important;
    .dx-box-flex {
      align-items: center !important;
    }
    .dx-calendar-view-month {
      margin: 0 !important;
      margin-right: 8px !important;
    }
    .dx-timeview {
      margin: 0 !important;
      margin-left: 8px !important;
    }
  }
  .dx-popup-bottom.dx-toolbar {
    padding: 0 16px;
    padding-bottom: 16px;
  }
  .dx-toolbar-items-container {
    .dx-toolbar-after {
      display: flex;
      flex-direction: row-reverse;
      .dx-toolbar-button {
        &:first-child {
          padding: 0;
        }
        &:last-child {
          padding-right: 8px;
        }
      }
    }
  }
}
// Style list time
.dx-datebox-wrapper-time {
  .dx-popup-content {
    padding: 0px !important;
  }
}
.dx-list:not(.dx-list-select-decorator-enabled)
  .dx-list-item.dx-list-item-selected {
  background: var(--date-picker-hover-bg) !important;
}
.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-active {
  background: var(--date-picker-hover-bg) !important;
  color: #212121;
}
</style>
